// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"d5c0a022c837f75541be","678":"f6a6c7ce60d7ac41140c","883":"aa0ed9a58f1441e0a9b5"}[chunkId] + ".js";
};